import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import Barcode from 'react-barcode';
import host from '../../assets/js/Host';

const ThermalReceipts = () => {
  const [receiptsData, setReceiptsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [logoSrc, setLogoSrc] = useState(null);
  const [showReceipts, setShowReceipts] = useState(false);
  const [searchNumber, setSearchNumber] = useState('');
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  // دالة لقص النص الطويل
  const truncateText = (text, maxLength = 100) => {
    if (!text) return "-";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  // دالة لاستيراد اللوغو
  const handleLogoUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoSrc(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // دالة البحث عن الوصل
  const searchReceipt = () => {
    if (!searchNumber.trim()) {
      alert('الرجاء إدخال رقم الوصل');
      return;
    }

    const found = receiptsData.find(receipt =>
      receipt.qrNumber === searchNumber.trim() ||
      receipt.barcodeNumber === searchNumber.trim() ||
      receipt.id.toString() === searchNumber.trim()
    );

    if (found) {
      setSelectedReceipt(found);
    } else {
      alert('لم يتم العثور على وصل بهذا الرقم');
      setSelectedReceipt(null);
    }
  };

  // دالة للطباعة
  const handlePrint = () => {
    if (!selectedReceipt) {
      alert('الرجاء البحث عن وصل أولاً');
      return;
    }

    setShowReceipts(true);
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowReceipts(false);
      }, 100);
    }, 100);
  };

  // دالة لطباعة جميع الوصولات
  const handlePrintAll = () => {
    setSelectedReceipt(null);
    setShowReceipts(true);
    setTimeout(() => {
      window.print();
      setTimeout(() => {
        setShowReceipts(false);
      }, 100);
    }, 100);
  };

  // الحصول على الوصولات للطباعة
  const getReceiptsForPrinting = () => {
    if (selectedReceipt) {
      return [selectedReceipt];
    }
    return receiptsData;
  };

  // مسح البحث
  const clearSearch = () => {
    setSearchNumber('');
    setSelectedReceipt(null);
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let Getid = urlParams.get('id')

    // جلب البيانات من API
    fetch(`${host}users/printed-orders/agre/${Getid}`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        // التحقق من وجود البيانات
        if (!data || !data.orders) {
          throw new Error('البيانات غير موجودة أو بتنسيق خاطئ');
        }

        // جلب الشعار من API
        if (data.logo) {
          setLogoSrc(data.logo);
        }

        // تحويل البيانات للتنسيق المطلوب
        const formattedData = data.orders.map(order => ({
          id: order.id,
          qrNumber: String(order.id),
          // qrNumber: String(order.ref_id || order.id || ""),
          barcodeNumber: String(order.id || "0"),
          customer: {
            name: order.name,
            phone: order.phone,
            secondaryPhone: "",
            province: order.government,
            area: order.city,
            landmark: order.address,
            deliveryDate: order.createdAt,
            price: `${(order.price * 1000).toLocaleString('EN-IQ')}`,
            totalPrice: `${(order.price * 1000).toLocaleString('EN-IQ')}`
          },
          notes: order.notes || " ",
          products: order.items.map(item => ({
            name: item.components.name,
            quantity: item.count
          }))
        }));

        setReceiptsData(formattedData);
        setLoading(false);
      })
      .catch(error => {
        console.error('خطأ في جلب البيانات:', error);

        // بيانات تجريبية للاختبار
        const demoData = [

        ];

        setReceiptsData(demoData);
        setError("تم تحميل بيانات تجريبية - تأكد من تشغيل API على http://localhost:5000");
        setLoading(false);
      });
  }, []);

  const styles = {
    // حاوية جميع الوصولات
    container: {
      width: '100%',
      margin: 0,
      padding: 0
    },

    // لوحة التحكم
    controlPanel: {
      backgroundColor: '#fff',
      padding: '20px',
      margin: '20px',
      borderRadius: '10px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      direction: 'rtl'
    },

    controlHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
      flexWrap: 'wrap',
      gap: '10px'
    },

    title: {
      fontSize: '24px',
      fontWeight: 'bold',
      color: '#333'
    },

    searchSection: {
      backgroundColor: '#f9f9f9',
      padding: '20px',
      borderRadius: '8px',
      marginTop: '20px'
    },

    searchTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '15px',
      color: '#333'
    },

    searchContainer: {
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      flexWrap: 'wrap'
    },

    searchInput: {
      flex: '1',
      minWidth: '200px',
      padding: '10px 15px',
      fontSize: '16px',
      border: '2px solid #ddd',
      borderRadius: '5px',
      outline: 'none',
      transition: 'border-color 0.3s'
    },

    searchButton: {
      backgroundColor: '#2196F3',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      transition: 'background-color 0.3s'
    },

    clearButton: {
      backgroundColor: '#f44336',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      transition: 'background-color 0.3s'
    },

    printAllButton: {
      backgroundColor: '#FF9800',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold',
      transition: 'background-color 0.3s'
    },

    uploadButton: {
      backgroundColor: '#4CAF50',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '5px',
      cursor: 'pointer',
      border: 'none',
      fontSize: '16px',
      fontWeight: 'bold'
    },

    selectedReceiptInfo: {
      marginTop: '20px',
      padding: '15px',
      backgroundColor: '#e3f2fd',
      borderRadius: '8px',
      border: '2px solid #2196F3'
    },

    receiptInfoTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: '#1976D2'
    },

    receiptDetails: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '10px',
      marginTop: '10px'
    },

    detailItem: {
      backgroundColor: 'white',
      padding: '8px 12px',
      borderRadius: '5px'
    },

    detailLabel: {
      fontWeight: 'bold',
      color: '#666',
      fontSize: '14px'
    },

    detailValue: {
      color: '#333',
      fontSize: '14px',
      marginTop: '2px'
    },

    statsContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '15px',
      marginTop: '20px'
    },

    statCard: {
      backgroundColor: '#f5f5f5',
      padding: '15px',
      borderRadius: '8px',
      textAlign: 'center',
      border: '1px solid #e0e0e0'
    },

    statLabel: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '5px'
    },

    statValue: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333'
    },

    // صفحة الوصل الواحد
    page: {
      width: '150mm',
      height: '150mm',
      margin: '0',
      padding: '0',
      backgroundColor: 'white',
      fontFamily: 'Arial, sans-serif',
      fontSize: '18px',
      direction: 'rtl',
      boxSizing: 'border-box',
      position: 'relative',
      pageBreakAfter: 'always',
      pageBreakInside: 'avoid',
      display: 'flex',
      flexDirection: 'column'
    },

    // القسم العلوي
    header: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      height: '60mm',
      padding: '2mm',
      boxSizing: 'border-box',
      gap: '1mm'
    },

    headerSection: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },

    qrCodeContainer: {
      width: '45mm',
      height: '45mm',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0.5mm',
      backgroundColor: 'white'
    },

    barcodeContainer: {
      width: '65mm',
      height: '40mm',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      backgroundColor: 'white'
    },

    logoBox: {
      width: '35mm',
      height: '35mm',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    logoImage: {
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'contain'
    },

    logoText: {
      fontSize: '20px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginTop: '2mm'
    },

    numberText: {
      fontSize: '25px',
      fontWeight: 'bold',
      marginTop: '1mm',
      textAlign: 'center'
    },

    // رسالة التحذير
    warningContainer: {
      height: '12mm',
      padding: '1mm 3mm',
      display: 'flex',
      alignItems: 'center'
    },

    warning: {
      width: '100%',
      padding: '2.5mm',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '20px',
      borderRadius: '3px',
      color: '#000',
    },

    // معلومات الزبون
    customerContainer: {
      height: '50mm',
      padding: '0 3mm',
      boxSizing: 'border-box',
    },

    customerSection: {
      height: '100%',
      padding: '2mm',
      boxSizing: 'border-box',
      overflow: 'hidden'
    },

    customerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '2mm',
      height: '100%'
    },

    infoCell: {
      fontSize: '14px',
      textAlign: 'center',
      padding: '2mm',
      backgroundColor: '#f9f9f9',
      borderRadius: '3px',
      border: '1.5px solid #e0e0e0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      overflow: 'hidden'
    },

    infoLabel: {
      fontWeight: 'bold',
      fontSize: '18px',
      marginBottom: '1mm',
      display: 'block',
      color: '#555'
    },

    infoValue: {
      fontWeight: 'bold',
      fontSize: '18px',
      display: 'block'
    },

    infoValueAddress: {
      fontWeight: 'bold',
      fontSize: '13px',
      display: 'block',
      lineHeight: '1.2',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      wordBreak: 'break-word'
    },

    // قسم السعر
    priceContainer: {
      height: '18mm',
      padding: '2mm 3mm',
      boxSizing: 'border-box'
    },

    priceSection: {
      textAlign: 'center',
      padding: '3mm',
      borderRadius: '4px',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },

    priceLabel: {
      fontWeight: 'bold',
      fontSize: '20px',
      display: 'block',
      marginBottom: '1mm',
      color: '#333'
    },

    // قسم الملاحظات
    notesContainer: {
      height: '25mm',
      padding: '1mm 3mm',
      boxSizing: 'border-box'
    },

    notesSection: {
      height: '100%',
      padding: '2mm',
      boxSizing: 'border-box'
    },

    notes: {
      height: 'calc(100% - 20px)',
      padding: '2mm',
      fontSize: '15px',
      lineHeight: '1.4',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      borderRadius: '3px'
    },

    // قسم المنتجات
    productsContainer: {
      flex: 1,
      padding: '0 3mm 3mm 3mm',
      boxSizing: 'border-box',
      minHeight: '20mm'
    },

    productsSection: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box'
    },

    sectionTitle: {
      fontWeight: 'bold',
      fontSize: '20px',
      marginBottom: '2mm',
      paddingBottom: '1mm',
      textAlign: 'center',
      lineHeight: '1'
    },

    productsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      flex: '1',
    },

    productCell: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f9f9f9',
      borderRadius: '3px',
      border: '1px solid #e0e0e0',
    },

    productName: {
      fontWeight: 'bold',
      fontSize: '20px',
      color: '#000'
    },

    productQty: {
      fontSize: '20px',
      fontWeight: 'bold',
      lineHeight: '1.2',
      color: '#000'
    },

    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '24px',
      fontWeight: 'bold',
      direction: 'rtl'
    }
  };

  // Logo مكون افتراضي
  const DefaultLogoIcon = () => (
    <svg width="100" height="100" viewBox="0 0 100 100">
      <rect x="20" y="35" width="60" height="35" fill="#000" />
      <polygon points="50,15 30,35 70,35" fill="#000" />
      <circle cx="50" cy="52" r="9" fill="#fff" />
      <rect x="10" y="63" width="80" height="6" fill="#000" />
      <rect x="40" y="75" width="20" height="15" fill="#000" />
    </svg>
  );

  // مكون الوصل الواحد
  const Receipt = ({ receiptData, isLastReceipt }) => (
    <div style={{ ...styles.page, ...(isLastReceipt ? { pageBreakAfter: 'auto' } : {}) }}>
      {/* القسم العلوي */}
      <div style={styles.header}>
        {/* QR Code */}
        <div style={styles.headerSection}>
          <div style={styles.qrCodeContainer}>
            <QRCodeSVG
              value={receiptData.qrNumber}
              size={350}
              level="L"
              includeMargin={true}
              bgColor="#FFFFFF"
              fgColor="#000000"
            />
          </div>
          <div style={styles.numberText}>
            {receiptData.qrNumber || "لا يوجد رقم"}
          </div>
        </div>

        {/* Logo */}
        <div style={styles.headerSection}>
          <div style={styles.logoBox}>
            {logoSrc ? (
              <img src={logoSrc} alt="Logo" style={styles.logoImage} />
            ) : (
              <DefaultLogoIcon />
            )}
          </div>
          <div style={styles.logoText}>عيون المستقبل</div>
        </div>

        {/* Barcode */}
        <div style={styles.headerSection}>
          <div style={styles.barcodeContainer}>
            <Barcode
              value={String(receiptData.barcodeNumber || "0")}
              width={2.2}
              height={75}
              fontSize={20}
              format="CODE128"
              displayValue={false}
              margin={0}
              background="#FFFFFF"
              lineColor="#000000"
            />
          </div>
          <div style={styles.numberText}>{receiptData.barcodeNumber}</div>
        </div>
      </div>

      {/* رسالة التحذير */}
      <div style={styles.warningContainer}>
        <div style={styles.warning}>
          المادة قابلة للكسر والفحص أمام المندوب فقط
        </div>
      </div>

      {/* معلومات الزبون */}
      <div style={styles.customerContainer}>
        <div style={styles.customerSection}>
          <div style={styles.customerGrid}>
            <div style={styles.infoCell}>
              <span style={styles.infoLabel}>تاريخ التسليم</span>
              <span style={styles.infoValue}>{receiptData.customer.deliveryDate}</span>
            </div>
            <div style={styles.infoCell}>
              <span style={styles.infoLabel}>رقم الهاتف</span>
              <span style={styles.infoValue}>{receiptData.customer.phone}</span>
            </div>
            <div style={styles.infoCell}>
              <span style={styles.infoLabel}>الهاتف الثانوي</span>
              <span style={styles.infoValue}>{receiptData.customer.secondaryPhone || "-"}</span>
            </div>
            <div style={styles.infoCell}>
              <span style={styles.infoLabel}>المحافظة</span>
              <span style={styles.infoValue}>{receiptData.customer.province}</span>
            </div>
            <div style={styles.infoCell}>
              <span style={styles.infoLabel}>المنطقة</span>
              <span style={styles.infoValue}>{receiptData.customer.area}</span>
            </div>
            <div style={styles.infoCell} title={receiptData.customer.landmark}>
              <span style={styles.infoLabel}>أقرب نقطة دالة</span>
              <span style={styles.infoValueAddress}>
                {truncateText(receiptData.customer.landmark, 100)}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* قسم السعر */}
      <div style={styles.priceContainer}>
        <div style={styles.priceSection}>
          <span style={styles.priceLabel}>السعر شامل اجور التوصيل : <b>{receiptData.customer.totalPrice}</b></span>
        </div>
      </div>

      {/* قسم الملاحظات */}
      <div style={styles.notesContainer}>
        <div style={styles.notesSection}>
          <div style={styles.sectionTitle}>الملاحظات</div>
          <div style={styles.notes}>
            {receiptData.notes}
          </div>
        </div>
      </div>

      {/* قسم المنتجات */}
      <div style={styles.productsContainer}>
        <div style={styles.productsSection}>
          <div style={styles.productsGrid}>
            {receiptData.products.map((product, index) => (
              <div key={index} style={styles.productCell}>
                <div style={styles.productName}>{product.name}</div>
                <div style={styles.productQty}>× {product.quantity}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // عرض شاشة التحميل
  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        جاري تحميل البيانات...
      </div>
    );
  }

  // عرض رسالة الخطأ إذا وجد
  if (error && !receiptsData.length) {
    return (
      <div style={styles.loadingContainer}>
        <div>
          <p style={{ color: '#d32f2f' }}>حدث خطأ في تحميل البيانات</p>
          <p style={{ fontSize: '14px', color: '#666' }}>{error}</p>
          <button onClick={() => window.location.reload()}
            style={{ padding: '10px 20px', marginTop: '10px', cursor: 'pointer' }}>
            إعادة المحاولة
          </button>
        </div>
      </div>
    );
  }

  // عرض رسالة إذا لم توجد بيانات
  if (!receiptsData.length) {
    return (
      <div style={styles.loadingContainer}>
        <div>
          <p>لا توجد طلبات لعرضها</p>
          <p style={{ fontSize: '14px', color: '#666' }}>
          </p>
        </div>
      </div>
    );
  }

  const receiptsForPrinting = getReceiptsForPrinting();

  return (
    <div style={styles.container}>
      {/* لوحة التحكم - تظهر فقط على الشاشة */}
      {!showReceipts && (
        <div className="no-print" style={styles.controlPanel}>
          <div style={styles.controlHeader}>
            <h1 style={styles.title}>نظام طباعة الوصولات</h1>

          </div>

          {/* إحصائيات */}
          <div style={styles.statsContainer}>
            <div style={styles.statCard}>
              <div style={styles.statLabel}>إجمالي الوصولات</div>
              <div style={styles.statValue}>{receiptsData.length}</div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statLabel}>الوصل المختار</div>
              <div style={styles.statValue}>
                {selectedReceipt ? selectedReceipt.qrNumber : '-'}
              </div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statLabel}>اسم الزبون</div>
              <div style={styles.statValue}>
                {selectedReceipt ? selectedReceipt.customer.name : '-'}
              </div>
            </div>
            <div style={styles.statCard}>
              <div style={styles.statLabel}>رقم الهاتف</div>
              <div style={styles.statValue}>
                {selectedReceipt ? selectedReceipt.customer.phone : '-'}
              </div>
            </div>
          </div>

          {/* البحث عن الوصل */}
          <div style={styles.searchSection}>
            <div style={styles.searchTitle}>البحث عن وصل محدد</div>
            <div style={styles.searchContainer}>
              <input
                type="text"
                placeholder="ادخل رقم الوصل (ref_id أو id)"
                value={searchNumber}
                onChange={(e) => setSearchNumber(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && searchReceipt()}
                style={styles.searchInput}
              />
              <button onClick={searchReceipt} style={styles.searchButton}>
                🔍 بحث
              </button>
              {selectedReceipt && (
                <>
                  <button onClick={handlePrint} style={{ ...styles.searchButton, backgroundColor: '#4CAF50' }}>
                    🖨️ طباعة الوصل المختار
                  </button>
                  <button onClick={clearSearch} style={styles.clearButton}>
                    ❌ مسح البحث
                  </button>
                </>
              )}
              <button onClick={handlePrintAll} style={styles.printAllButton}>
                🖨️ طباعة جميع الوصولات ({receiptsData.length})
              </button>
            </div>
          </div>

          {/* معلومات الوصل المختار */}
          {selectedReceipt && (
            <div style={styles.selectedReceiptInfo}>
              <div style={styles.receiptInfoTitle}>معلومات الوصل المختار</div>
              <div style={styles.receiptDetails}>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>رقم الوصل:</div>
                  <div style={styles.detailValue}>{selectedReceipt.qrNumber}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>اسم الزبون:</div>
                  <div style={styles.detailValue}>{selectedReceipt.customer.name}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>المحافظة:</div>
                  <div style={styles.detailValue}>{selectedReceipt.customer.province}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>المنطقة:</div>
                  <div style={styles.detailValue}>{selectedReceipt.customer.area}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>السعر:</div>
                  <div style={styles.detailValue}>{selectedReceipt.customer.totalPrice}</div>
                </div>
                <div style={styles.detailItem}>
                  <div style={styles.detailLabel}>عدد المنتجات:</div>
                  <div style={styles.detailValue}>{selectedReceipt.products.length}</div>
                </div>
              </div>
            </div>
          )}

          {/* عرض تحذير إذا كانت بيانات تجريبية */}
          {error && (
            <div style={{
              background: '#fff3cd',
              border: '1px solid #ffc107',
              borderRadius: '4px',
              padding: '10px',
              marginTop: '20px',
              textAlign: 'center'
            }}>
              ⚠️ {error}
            </div>
          )}

          {/* تعليمات الاستخدام */}
          <div style={{
            marginTop: '20px',
            padding: '15px',
            backgroundColor: '#f0f8ff',
            borderRadius: '8px',
            border: '1px solid #b3d9ff'
          }}>
            <h3 style={{ color: '#0066cc', marginBottom: '10px' }}>📋 تعليمات الاستخدام:</h3>
            <ul style={{ lineHeight: '1.8', color: '#333' }}>
              <li>للبحث عن وصل محدد: ادخل رقم الوصل (ref_id أو id) واضغط بحث</li>
              <li>بعد العثور على الوصل، اضغط "طباعة الوصل المختار" لطباعته</li>
              <li>لطباعة جميع الوصولات: اضغط "طباعة جميع الوصولات"</li>
              <li>لمسح البحث والبدء من جديد: اضغط "مسح البحث"</li>
              <li>يمكنك رفع شعار مخصص بالضغط على "رفع شعار جديد"</li>
            </ul>
          </div>
        </div>
      )}

      {/* عرض الوصولات للطباعة */}
      {showReceipts && (
        <div id="receipts-to-print">
          {receiptsForPrinting.map((receipt, index) => (
            <Receipt
              key={receipt.id}
              receiptData={receipt}
              isLastReceipt={index === receiptsForPrinting.length - 1}
            />
          ))}
        </div>
      )}

      {/* أنماط الطباعة */}
      <style>{`
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          
          @page {
            size: 150mm 150mm;
            margin: 0;
          }
          
          body {
            margin: 0 !important;
            padding: 0 !important;
            background: white !important;
          }
          
          body > *:not(#root) {
            display: none !important;
          }

          .no-print {
            display: none !important;
          }
        }
        
        @media screen {
          body {
            background: #f0f0f0;
            margin: 0;
            padding: 0;
          }
          
          #receipts-to-print > div {
            margin: 20px auto;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }
        }
        
        body, #root {
          margin: 0;
          padding: 0;
        }

        input[type="text"]:focus {
          border-color: #2196F3 !important;
          box-shadow: 0 0 5px rgba(33, 150, 243, 0.3);
        }

        button:hover {
          opacity: 0.9;
        }

        button:active {
          transform: scale(0.98);
        }
      `}</style>
    </div>
  );
};

export default ThermalReceipts;